import Home from "../components/Home"
import Wallets from "../components/Wallets"
import Transaction from "../components/Transaction"
import PopupTransactionInit from "components/Popup/TransactionInit";
import PopupTransactionFinish from "components/Popup/TransactionFinish";
import PopupGeneralInit from "components/Popup/GeneralInit";
import PopupGeneralFinish from "components/Popup/GeneralFinish";
import PopupBalanceLock from "components/Popup/BalanceLock";
import PopupBalanceCharge from "components/Popup/BalanceCharge";
import PopupWalletManage from "components/Popup/WalletManage";
import WalletDetails from '../components/Popup/WalletDetails';
import { pathRoutes } from "libs/constans";
import Authentication from "components/Authentication";

const routes = [
  {
    path: "/",
    component: Home,
    exact: true
  },
  {
    path: "/authenticate",
    component: Authentication,
    exact: true
  },
  {
    path: "/checkAuthenticated",
    component: Authentication,
    exact: true
  },
  {
    path: "/logout",
    component: Authentication,
    exact: true
  },
  {
    path: "/login",
    component: Authentication,
    exact: true
  },
  {
    path: "/wallets/*",//action=claim/link/manage
    component: Wallets
  },
  {
    path: "/transaction/*/*", //action = sign/execute, type = ethereum_raw/ethereum_contract_execution/ETHEREUM_TRANSACTION/eth_transaction/ethereum_eip712
    component: Transaction
  },
  {
    path: "/popup/balance/lock",
    component: PopupBalanceLock
  },
  {
    path: "/popup/balance/charge",
    component: PopupBalanceCharge
  },
  {
    path: pathRoutes.WALLET_MANAGER,
    component: PopupWalletManage
  },
  {
    path: pathRoutes.WALLET_DETAILS + `/:walletId`,
    component: WalletDetails
  },
  {
    path: "/popup/transaction/init.html",
    component: PopupTransactionInit
  },
  {
    path: "/popup/transaction/finish.html",
    component: PopupTransactionFinish
  },
  {
    path: "/popup/general/init.html",
    component: PopupGeneralInit
  },
  {
    path: "/popup/general/finish.html",
    component: PopupGeneralFinish
  }

];
export default routes;
